import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveDirective as _resolveDirective, withCtx as _withCtx, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

import { useFormErrorMessageHandler } from '@/utils/form';
import { PropType, computed } from 'vue';
import { useI18n } from 'vue-i18n';

import { useGetDeviceQuery, useCloneDeviceMutation } from '@/entities/device/hooks';
import { useForm } from '@/core/hooks/forms';

import { Device } from '@/entities/device/types';

import {
  NkStack,
  NkGroup,
  NkButton,
} from '@/core/components';
import { ElAlert, ElNotification } from 'element-plus';


export default /*#__PURE__*/_defineComponent({
  __name: 'DeviceCloneForm',
  props: {
  id: {
    type: Number as PropType<Device['id']>,
    required: true,
    default: null,
  },
},
  emits: ['submitted'],
  setup(__props, { emit }) {

const props = __props

const { t } = useI18n();


const { onSubmitted } = useForm(emit);



const deviceQueryData = computed(() => ({ id: props.id }));
const hasDeviceQueryData = computed(() => !!deviceQueryData.value.id);
const {
  data: device,
  isLoading,
} = useGetDeviceQuery(deviceQueryData, { enabled: hasDeviceQueryData });

const {
  mutateAsync,
  isError,
  isLoading: isCloningLoading,
  error: cloneDeviceError,
} = useCloneDeviceMutation();

const { error } = useFormErrorMessageHandler(cloneDeviceError);

const handleSubmit = () => {
  if (!isCloningLoading.value) {
    mutateAsync(
      device.value as Device,
      {
        onSuccess: () => {
          ElNotification({
            title: t('device.notification.clone.title'),
            message: t('device.notification.clone.message'),
            type: 'success',
            position: 'bottom-right',
          });
        },
      },
    ).then((res) => {
      onSubmitted(res);
    });
  }
};

return (_ctx: any,_cache: any) => {
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_unref(NkStack), null, {
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createBlock(_unref(NkStack), null, {
        default: _withCtx(() => [
          (_unref(isError))
            ? (_openBlock(), _createBlock(_unref(ElAlert), {
                key: 0,
                title: _unref(error),
                type: "error",
                class: "mb-2"
              }, null, 8, ["title"]))
            : _createCommentVNode("", true),
          _createVNode(_unref(ElAlert), {
            title: _ctx.$t('device.action.clone.warning'),
            description: _unref(device).deviceValues[0].value,
            type: "warning",
            closable: false,
            effect: "dark"
          }, null, 8, ["title", "description"])
        ]),
        _: 1
      })), [
        [_directive_loading, _unref(isLoading)]
      ]),
      _createVNode(_unref(NkGroup), { position: "right" }, {
        default: _withCtx(() => [
          _withDirectives((_openBlock(), _createBlock(_unref(NkButton), {
            onClick: handleSubmit,
            icon: "NkBuild"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('device.action.clone_device')), 1)
            ]),
            _: 1
          })), [
            [_directive_loading, _unref(isCloningLoading)]
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})